module.exports = ".nav-custom-bar {\n    background-color: #0F1577;\n    min-height: 100%;\n    -webkit-box-shadow: 0px 0px 0px;\n            box-shadow: 0px 0px 0px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n\n.img{\n    margin-left: 18px;\n    height: 72.59px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n@media(max-width: 570px){\n    .nav-custom-bar{\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;      \n\t}\n}\n\n.img-header{\n    width:140px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/navbar/navbar.component.css
// module id = ./src/app/shared/navbar/navbar.component.css
// module chunks = main